import { render, staticRenderFns } from "./view-video.vue?vue&type=template&id=a1dce80a&scoped=true&"
import script from "./view-video.vue?vue&type=script&lang=js&"
export * from "./view-video.vue?vue&type=script&lang=js&"
import style0 from "./view-video.vue?vue&type=style&index=0&id=a1dce80a&lang=scss&scoped=true&"
import style1 from "@/assets/range-slider.scss?vue&type=style&index=1&id=a1dce80a&scoped=true&lang=scss&"
import style2 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=2&id=a1dce80a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dce80a",
  null
  
)

component.options.__file = "view-video.vue"
export default component.exports